import { useDeviceType } from './useDeviceType';
import { useMediaBreakpoints } from '../hooks/useMediaBreakpoints';
import { sizes } from '../breakpoints';
export const useMobileFeature = (useFeature = true, forceFeature = false) => {
  const {
    isMobile,
    isTablet,
    isIOS,
    isAndroid,
    isIOS13,
    isWindowsPhone
  } = useDeviceType();
  const screen = useMediaBreakpoints(sizes);
  if (forceFeature) {
    return true;
  }
  if (!useFeature) {
    return false;
  }
  return screen === 'xs' || isMobile || isTablet || isIOS || isAndroid || isIOS13 || isWindowsPhone;
};